function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { defaultMarkdownSerializer, MarkdownSerializer } from 'prosemirror-markdown';
import { serializeVariableFn } from './serializer/utils';
import { DocFormatEnum, getDocFormat } from './utils';

/*
  A class that determines the serializing method for the HTML that the editor renders.
  This determines the string format that gets passing into @onContentChange
*/

export class Serializer {
  constructor(args) {
    _defineProperty(this, "schema", void 0);
    _defineProperty(this, "variables", void 0);
    _defineProperty(this, "serializer", void 0);
    Object.assign(this, args);
    this.serializer = new MarkdownSerializer(this.nodes, this.marks);
  }
  serialize(doc) {
    const serialized = this.serializer.serialize(doc);

    // NOTE supports existing restriction with the NDA form
    if (getDocFormat(this.schema) === DocFormatEnum.Nda) return serialized.replaceAll('**', '');
    return serialized;
  }
  get nodes() {
    const nodes = {
      ...defaultMarkdownSerializer.nodes,
      pillbox: (state, node) => {
        state.write(node.attrs.token);
        state.renderInline(node);
      }
    };
    if (this.variables) {
      [...this.variables, 'invalidVariable'].reduce((result, variable) => {
        result[variable] = serializeVariableFn(this.schema);
        return result;
      }, nodes);
    }
    return nodes;
  }
  get marks() {
    return {
      ...defaultMarkdownSerializer.marks
    };
  }
}